import '@stoplight/elements-core/styles.css';

import { API } from '@stoplight/elements';
import { Box } from '@stoplight/mosaic';
import React from 'react';

import { renderExtensionRenderer } from './ExtensionRenderer';

export const ElementsAPI: React.FC = () => {
  const apiDescriptionUrl =
    process.env.COM_SFC_EFOYCLOUD_PUBLIC_API_FULL_URL ||
    `${process.env.COM_SFC_EFOYCLOUD_PUBLIC_API_BASE_URL || ''}/v3/api-docs`;

  return (
    <Box flex={1} overflowY={'hidden'}>
      <API
        apiDescriptionUrl={apiDescriptionUrl}
        router="history"
        layout="responsive"
        hideExport={true}
        hideSchemas={true}
        renderExtensionAddon={renderExtensionRenderer}
      />
    </Box>
  );
};
